import React from "react";
import { Link, Outlet } from "react-router-dom";
import { Facebook, Linkedin, Instagram } from "lucide-react";
import Header from "./Header";

// Live assets
const LOGO_URL = "https://customer-assets.emergentagent.com/job_frog-ecodev/artifacts/3z4427yl_image.png";

const PublicLayout = () => {
  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-900 bg-white">
      <Header />

      {/* Main Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-gray-400 py-16 text-sm font-sans border-t-8 border-primary">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-12 text-center md:text-left">
          
          <div className="space-y-6">
            <h4 className="text-white font-heading font-bold text-lg uppercase tracking-widest">Frog Lake</h4>
            <p className="leading-relaxed text-gray-500">
              "We are determined to do good things and committed to achieving results"
            </p>
            <div className="flex gap-4 justify-center md:justify-start">
               <Facebook className="h-5 w-5 hover:text-primary cursor-pointer transition-colors" />
               <Linkedin className="h-5 w-5 hover:text-primary cursor-pointer transition-colors" />
               <Instagram className="h-5 w-5 hover:text-primary cursor-pointer transition-colors" />
            </div>
          </div>

          <div>
            <h4 className="text-white font-heading font-bold text-lg uppercase tracking-widest mb-6">Quick Links</h4>
            <ul className="space-y-3 uppercase text-xs font-bold tracking-wider">
              <li><Link to="/jobs" className="hover:text-primary transition-colors">Employment</Link></li>
              <li><Link to="/business" className="hover:text-primary transition-colors">Business Directory</Link></li>
              <li><Link to="/tenders" className="hover:text-primary transition-colors">Tenders</Link></li>
              <li><Link to="/partners" className="hover:text-primary transition-colors">Partners</Link></li>
            </ul>
          </div>

           <div>
            <h4 className="text-white font-heading font-bold text-lg uppercase tracking-widest mb-6">Community</h4>
            <ul className="space-y-3 uppercase text-xs font-bold tracking-wider">
              <li><Link to="/events" className="hover:text-primary transition-colors">Events Calendar</Link></li>
              <li><Link to="/programs" className="hover:text-primary transition-colors">Programs</Link></li>
              <li><Link to="/elders" className="hover:text-primary transition-colors">Elders Services</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-bold text-lg uppercase tracking-widest mb-6">Contact</h4>
            <address className="not-italic space-y-3 text-gray-500">
              <p>Frog Lake, AB T0A 1M0</p>
              <p>Phone: (780) 943-3737</p>
              <p>Email: info@froglake.ca</p>
            </address>
          </div>
        </div>
        
        <div className="container mx-auto px-4 mt-16 pt-8 border-t border-zinc-800 text-center text-xs text-zinc-600 uppercase tracking-widest">
          © {new Date().getFullYear()} Frog Lake First Nations
          <span className="mx-2 text-zinc-700">·</span>
          <Link to="/proposal" data-testid="footer-proposal-link" className="hover:text-primary transition-colors">
            Proposal
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
